import {get, post} from "../../../utils/request";
import {USER_SMS_CODE,USER_BIND_PHONE,MEMBER_LOGIN} from '../../../utils/api';


export const sendMessageActionResult = (params) => {
    return async (dispatch) => {
        const result = await post(USER_SMS_CODE, params);
        return result;
    }
}

export const bindPhoneActionResult = (params) => {
    return async (dispatch) => {
        const result = await post(USER_BIND_PHONE, params);
        return result;
    }
}

export const memberLogin = (params) => {
    return async (dispatch) => {
        const result = await post(MEMBER_LOGIN, params);
        return result;
    }
}
